export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"

export const USER_ICON = "https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg"

export const API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer ' + process.env.REACT_APP_TMDB_KEY
  }
};

export const BG_URL = "https://assets.nflxext.com/ffe/siteui/vlv3/bfc0fc46-24f6-4d70-85b3-7799315c01dd/web/IN-en-20240923-TRIFECTA-perspective_74e21c19-980e-45ef-bd6c-78c1a6ce9381_large.jpg"

export const IMG_CDN_URL = 'https://image.tmdb.org/t/p/w200'

export const SUPPORTED_LANGUAGES = [
  {identifier: 'en', name: 'English'},
  {identifier: 'hin', name: 'Hindi'},
  {identifier: 'spanish', name: 'Spanish'},
  {identifier: 'french', name: 'French'},
  {identifier: 'german', name: 'German'},
]

export const OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY